// services/authService.js
import { encryptData, decryptData } from '../utils/encryption';

const API_BASE_URL = 'https://usefullsofware.com/visioner7_api_services/v1/dxn/';

// Clave con la que se guarda el usuario cifrado
const USER_STORAGE_KEY = 'user_encrypted';

export const authService = {
    async login(email, password) {
        try {
            const response = await fetch(`${API_BASE_URL}login.php`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify({ email, contraseña: password })
            });

            const contentType = response.headers.get('content-type');
            if (!contentType || !contentType.includes('application/json')) {
                const text = await response.text();
                console.error('Respuesta no JSON:', text);
                return { success: false, error: 'El servidor respondió con un formato inválido' };
            }

            const data = await response.json();

            if (data.estado === 1) {
                const user = {
                    email: email,
                    nombre: data.nombre || 'Usuario',
                    licencia: data.licencia || {}
                };

                // Cifrar y guardar el usuario
                const encryptedUser = encryptData(user);
                localStorage.setItem(USER_STORAGE_KEY, encryptedUser);
                localStorage.setItem('auth_token', data.token);

                return {
                    success: true,
                    user: user,
                    token: data.token
                };
            } else {
                return {
                    success: false,
                    error: data.mensaje || 'Error en el inicio de sesión'
                };
            }
        } catch (error) {
            console.error('Error en login:', error);
            return {
                success: false,
                error: 'Error de conexión. Verifique su internet o que el servidor esté disponible.'
            };
        }
    },

    async register(userData) {
        try {
            const response = await fetch(`${API_BASE_URL}register.php`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify({
                    email: userData.email,
                    contraseña: userData.password,
                    nombre: `${userData.firstName} ${userData.lastName}`.trim(),
                    phone: userData.phone || '',
                    company: userData.company || '',
                    tipo_licencia: 'Free'
                })
            });

            const data = await response.json();

            if (data.estado === 1) {
                return { success: true, message: data.mensaje };
            } else {
                return { success: false, error: data.mensaje || 'Error en el registro' };
            }
        } catch (error) {
            console.error('Error en registro:', error);
            return { success: false, error: 'Error de conexión con el servidor' };
        }
    },

    logout() {
        localStorage.removeItem('auth_token');
        localStorage.removeItem(USER_STORAGE_KEY);
        window.location.href = '/login';
    },

    /**
     * Obtiene el usuario descifrado desde localStorage
     * @returns {Object|null} Objeto usuario o null si no existe o falla el descifrado
     */
    getCurrentUser() {
        const encrypted = localStorage.getItem(USER_STORAGE_KEY);
        if (!encrypted) return null;
        return decryptData(encrypted);
    },

    /**
     * Actualiza los datos del usuario en localStorage (cifrado)
     * @param {Object} user - Objeto usuario completo
     */
    updateUser(user) {
        const encrypted = encryptData(user);
        localStorage.setItem(USER_STORAGE_KEY, encrypted);
    },

    getAuthToken() {
        return localStorage.getItem('auth_token');
    },

    isAuthenticated() {
        const token = localStorage.getItem('auth_token');
        return !!token && token.length > 20;
    }
};